module.exports = __webpack_public_path__ + "static/9-acd8c9eb96cb4a6ac0140ea9d5ce034b.jpg";